import { AES, enc, mode, pad } from 'crypto-js';

export class CryptoService {
  static mode = mode.ECB;
  static padding = pad.Pkcs7;

  // function hitting twice for every character in grid table, data=undefined for after git
  static encrypt(data) {
    let encrypted_data = '';
    try {
      encrypted_data = AES.encrypt(data, process.env.REACT_APP_SECRET_KEY, {
        mode: CryptoService.mode,
        padding: CryptoService.padding,
      }).toString();
      encrypted_data = CryptoService.toBase64Url(encrypted_data);
      // eslint-disable-next-line no-unused-vars
    } catch (_) {
      return '';
    }
    return encrypted_data;
  }

  static decrypt = (data) => {
    let decrypted_data = '';
    try {
      decrypted_data = CryptoService.fromBase64Url(data);
      decrypted_data = AES.decrypt(
        decrypted_data,
        process.env.REACT_APP_SECRET_KEY,
        {
          mode: CryptoService.mode,
          padding: CryptoService.padding,
        },
      ).toString(enc.Utf8);
      const decrypted = decrypted_data?.toString();

      if (!decrypted) {
        return null;
      }

      // Try parsing JSON safely
      try {
        return JSON.parse(decrypted);
      } catch {
        return decrypted; // return plain string if not JSON
      }
    } catch (error) {
      return error;
    }
    return decrypted_data;
  };

  static sanitizeEncryptedString = (data) => {
    return data.replace(/\s+/g, '');
  };

  static toBase64Url(data) {
    return data
      .toString()
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  static fromBase64Url = (base64Url) => {
    const base64 = base64Url
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(base64Url.length + ((4 - (base64Url.length % 4)) % 4), '=');
    return base64;
  };
}